import type { ErrorEvent, EventHint } from '@sentry/core'

const CHUNK_ERROR_PATTERNS: RegExp[] = [
  /^ChunkLoadError$/,
  /Loading chunk \d+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
]

/**
 * ChunkLoadError случается когда пользователь на старом bundle после deploy — это
 * expected UX (RouteErrorBoundary ловит, делает reload один раз). Слать такое в
 * Sentry значит шуметь каждым deploy'ем. Фильтруем.
 *
 * Vite специфично: два варианта имени — 'ChunkLoadError' и 'Failed to fetch
 * dynamically imported module'. Покрываем оба.
 */
export function beforeSend(event: ErrorEvent, hint?: EventHint): ErrorEvent | null {
  const err = hint?.originalException
  if (err instanceof Error) {
    const name = err.name || ''
    const message = err.message || ''
    if (CHUNK_ERROR_PATTERNS.some((re) => re.test(name) || re.test(message))) {
      return null
    }
  }
  // Fallback: event без hint (например из replay/browser integration)
  const exceptionValue = event.exception?.values?.[0]
  if (exceptionValue) {
    const type = exceptionValue.type || ''
    const value = exceptionValue.value || ''
    if (CHUNK_ERROR_PATTERNS.some((re) => re.test(type) || re.test(value))) {
      return null
    }
  }
  return event
}

export function isChunkError(err: Error | undefined): boolean {
  if (!err) return false
  return CHUNK_ERROR_PATTERNS.some((re) => re.test(err.name) || re.test(err.message || ''))
}
